import { ConversationMessage } from "../../../../../model/integration/dto/meta/MetaConversationMessage";
import { getMediaUrl } from "../../../../../utils/Media";

/** Message types that arrive as a file rather than as text. */
const DOWNLOADABLE_TYPES = ["image", "video", "audio", "document", "sticker"];

export const isDownloadable = (message: ConversationMessage) =>
  Boolean(message.mediaId) && DOWNLOADABLE_TYPES.includes(message.type);

/** What to call the file on disk.
 *
 * Only a document carries a name of its own; the rest get a short piece of the
 * message id and the time saved, so a folder of them stays distinguishable.
 */
export const downloadNameFor = (message: ConversationMessage) => {
  if (message.document?.filename) {
    return message.document.filename;
  }

  const extension =
    message.type === "image"
      ? "jpg"
      : message.type === "video"
        ? "mp4"
        : message.type === "audio"
          ? "ogg"
          : "bin";

  return `whatsapp-${message.type}-${String(message._id).slice(0, 4)}-${Date.now()}.${extension}`;
};

/** Saves the attachment rather than opening it.
 *
 * The API is on another origin, so the `download` attribute on a link is
 * ignored - asking for it explicitly is what makes the response come back as
 * an attachment instead of a redirect to storage.
 */
export const downloadMessageMedia = (message: ConversationMessage) => {
  if (!message.mediaId) {
    return;
  }

  const name = downloadNameFor(message);

  const link = document.createElement("a");
  link.href = getMediaUrl(message.mediaId, { download: 1, name });
  link.download = name;
  link.rel = "noopener";

  document.body.appendChild(link);
  link.click();
  link.remove();
};
